import { HookReadMoreActions } from './read-more';
import { setWrapperWidth } from './owl-carousel';
import { setTopSpace } from './top-space';

var $ = jQuery;

window.addEventListener( 'DOMContentLoaded', () => {

    if ( $( window ).width() > 767 ) {
        setTopSpace( [document.getElementById('o-konferencji'), document.getElementById('agenda'), document.getElementById('prelegenci'), document.getElementById('cennik')] );
    }

    HookReadMoreActions( 'conference' );
    HookMenuOptions();

    if ( $( window ).width() < 768 ) {
        $(".wp-block-columns.owl-carousel").owlCarousel({
            dots: false,
            loop: true,
            nav: false,
            items: 1,
            margin: 40,
            autoWidth: true,
            onInitialized: callback,
        });

        setWrapperWidth( '.wp-block-columns.owl-carousel' );
    }

    let asignButton = document.querySelector(".wp-block-pik-submit-to-training--active .wp-block-pik-submit-to-training__submit > button")

    asignButton.addEventListener('click', (event) => {
        toggleForm(true, 'step1')
    })

    window.addEventListener('HIDE_FORM', () => {
        toggleForm(false)
    })

})

const callback = () => {
    toggleText();
}

/**
 * It does the same as mobileReadMore function in read-more.js but in different way to make it work in Owl carousel
 */
const toggleText = () => {

    $('.owl-carousel').on('click', '.mobile-read-more-switch p', function() {
        var targetElement = $(this).parent().parent().find('.wp-block-pik-read-more-text');

        if ( targetElement.hasClass('mobile-read-more') ) {

            setTimeout( function() {
                targetElement.removeClass('mobile-read-more');
            }, 100 );

            $(this).parent().parent().hide().show(0);

            $(this).parent().removeClass('show-content');
            $(this).parent().addClass('hide-content');
        } else {

            setTimeout( function() {
                targetElement.addClass('mobile-read-more');
            }, 100 );

            $(this).parent().parent().hide().show(0);

            $(this).parent().removeClass('hide-content');
            $(this).parent().addClass('show-content');
        }
    });
}

function toggleForm (state,setHash) {
    let conferenceContentContainer = document.querySelector('#page-content')
    let form = document.querySelector('#conferenceForm')
    let formScrollAnchor = document.querySelector('.saleForm_training_title_container');
    const header = document.querySelector('header.header');

    if (state) {
        if(setHash){
            window.location.hash = setHash
        }

        conferenceContentContainer.classList.add('hidden')
        form.classList.remove('hidden')
        scrollIntoViewWithOffset(formScrollAnchor)

        header.classList.add('header--default');
    } else {
        window.location.hash = ''
        conferenceContentContainer.classList.remove('hidden')
        form.classList.add('hidden')
        scrollIntoViewWithOffset(conferenceContentContainer)

        header.classList.remove('header--default');
    }
}

/**
 * This function hides sale form after click on conference menu link, to allow auto-scroll to anchor element from link
 */
function HookMenuOptions() {
    let allMenuLinks = document.querySelectorAll('#conference-menu-list > li')
    if (allMenuLinks) {
        allMenuLinks.forEach((link) => {
            link.addEventListener('click', () => {
                toggleForm(false)
            })

        })
    }
}

const scrollIntoViewWithOffset = (element, offsetOverwrite) => {
    const header = document.querySelector('#masthead')
    const headerHeight = header.offsetHeight
    const offset = offsetOverwrite ? offsetOverwrite : headerHeight
    window.scrollTo({
        behavior: 'smooth',
        top:
          element.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          offset,
    })
}